// extracted by mini-css-extract-plugin
export default {"breadcrumb":"breadcrumb_breadcrumb__RiVmz","breadcrumb-item":"breadcrumb_breadcrumb-item__LzLA0","active":"breadcrumb_active__bsRwt"};